import type { LiveEvent, Session } from "@src/types/index.interface";

import { useState, type ReactNode } from "react";

import { getComponent } from "../../src/utils.js";

import MobileNav from "./mobile-nav";
import DesktopNav from "./desktop-nav";

import algoliasearch from "algoliasearch/lite";

type CProps = {
  session: Session;
  children: ReactNode;
  liveEvents: LiveEvent[];
};

const Header: React.FC<CProps> = ({ session, children, liveEvents }) => {
  const [modalSearchState, setModalSearchState] = useState(false);

  const algoliaClient = algoliasearch(
    process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
    process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY!
  );

  return (
    <header className="w-full top-0 z-50 fixed">
      <MobileNav
        liveEvents={liveEvents}
        session={session}
        setModalSearchState={setModalSearchState}
        modalSearchState={modalSearchState}
        searchState=""
        algoliaClient={algoliaClient}
      >
        {getComponent(children, "DropdownPanelMobile")}
      </MobileNav>

      <DesktopNav
        liveEvents={liveEvents}
        session={session}
        setModalSearchState={setModalSearchState}
        modalSearchState={modalSearchState}
        searchState=""
        algoliaClient={algoliaClient}
      >
        {getComponent(children, "DropdownPanelDesktop")}
      </DesktopNav>
    </header>
  );
};

export default Header;
